
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from "@clerk/clerk-react";
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { ssrDocument } from './utils/ssrUtils';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Clerk Publishable Key. Please add VITE_CLERK_PUBLISHABLE_KEY in your .env file.");
}

// Validate the key format (basic check)
if (!PUBLISHABLE_KEY.startsWith('pk_')) {
  throw new Error("Invalid Clerk Publishable Key format. Key must start with 'pk_'.");
}

// Only run in browser environment
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const rootElement = ssrDocument.getElementById("root");

  if (!rootElement) {
    throw new Error("Root element not found");
  }

  const root = createRoot(rootElement);
  
  root.render(
    <HelmetProvider>
      <ClerkProvider 
        publishableKey={PUBLISHABLE_KEY}
        // Optional: Add domain restrictions or other security configs
        // appearance={{}} // Optional styling
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ClerkProvider>
    </HelmetProvider>
  );

  // Initialize iubenda CMP service
  // DISABLED: Service initialization interferes with native Iubenda button handlers on mobile
  // Scripts are already loaded in index.html with proper configuration
  // iubendaService.initialize().catch(console.error);

  // Dispatch render event for prerenderer after ensuring React Helmet has updated meta tags
  setTimeout(() => {
    if (typeof document !== 'undefined') {
      // Wait for React Helmet to update the DOM
      const checkHelmetReady = () => {
        const titleElement = document.querySelector('title');
        const descriptionElement = document.querySelector('meta[name="description"]');
        
        // Check if React Helmet has updated the meta tags (they should be different from defaults)
        if (titleElement && descriptionElement) {
          document.dispatchEvent(new Event('render-event'));
        } else {
          // Retry after a short delay if not ready
          setTimeout(checkHelmetReady, 100);
        }
      };
      
      checkHelmetReady();
    }
  }, 1500); // Increased initial delay to ensure React components are mounted
}
